import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import '../styles/loaders.less';
const AjaxLoader = ({ text = '', className = '' }) => {
    return (_jsx("div", Object.assign({ className: 'ajax-loader fade-in-with-delay ' + className }, { children: _jsxs("div", Object.assign({ className: "middle-holder" }, { children: [_jsx("div", { className: "loader-image" }), _jsx("span", Object.assign({ className: "ajax-text" }, { children: text }))] })) })));
};
export default AjaxLoader;
